import type { ReactNode } from 'react';
import { ChevronDown } from 'lucide-react';

export function AccordionSection({
  title,
  icon,
  iconColor,
  isOpen,
  onToggle,
  children,
  dataTour,
}: {
  title: string;
  icon: ReactNode;
  iconColor: string;
  isOpen: boolean;
  onToggle: () => void;
  children: ReactNode;
  dataTour?: string;
}) {
  return (
    <div className="border-b border-border last:border-b-0" data-tour={dataTour}>
      <button
        type="button"
        onClick={onToggle}
        className="w-full py-3 flex items-center justify-between hover:bg-white/[0.02] cursor-pointer transition-colors"
      >
        <span className="flex items-center gap-2 text-xs font-extrabold">
          <span className={iconColor}>{icon}</span>
          {title}
        </span>
        <ChevronDown
          size={16}
          className={`text-ink-4 transition-transform duration-200 ${isOpen ? 'rotate-180' : ''}`}
        />
      </button>
      {isOpen && <div className="pt-1 pb-4">{children}</div>}
    </div>
  );
}
